define('usuario-minha-conta-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('usuario.minha.conta.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('UsuarioMinhaConta', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
      return {
        getInfo:function(){
          return $q(function (resolve, reject) {
            return $http.get(appRoute.linkTo('usuarioMinhaConta.index')).success(function (data) {
              resolve(data);
            }).error(function (error) {
              $state.go('dashboard');
              reject(error);
            });
          });
        },
        updateUsuario:function(data){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('usuarioMinhaConta.updateUsuario'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        }
      }
    }]);
});
